import Helper from './Helper';

class InteractiveLegend {
  constructor() {
    this.trigger = document.querySelectorAll('rect[data-name*="legend"]');
    this.triggers = Array.prototype.slice.call(this.trigger);
    this.target = document.querySelectorAll('svg[data-name*="target"]');
    this.targets = Array.prototype.slice.call(this.target);

    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach(el => {
      let id = el.dataset.name.split('_')[0];
      let target = this.targets.find(item => {
        return item.dataset.name.split('_')[0] == id;
      });

      el.addEventListener('click', () => {
        // If target is already active, remove the 'active' class.
        if (target.classList.contains('active')) {
          target.classList.remove('active');
        } else {
          // Close all other targets before adding 'active' to this one
          this.closeAll();
          target.classList.add('active');
        }

        // Check if any element has 'active' and add/remove 'invisible' class to 'test' elements
        this.toggleInvisibleClass();
      });
    });

    this.targets.forEach(el => {
      el.addEventListener('click', () => {
        // If the clicked target is already active, close it
        if (el.classList.contains('active')) {
          el.classList.remove('active');
        } else {
          this.closeAll();
          el.classList.add('active');
        }

        // Check if any element has 'active' and add/remove 'invisible' class to 'test' elements
        this.toggleInvisibleClass();
      });
    });
  }

  toggleInvisibleClass() {
    const testElements = document.querySelectorAll('.worldmap-svg-part__5');
    const activeElements = document.querySelectorAll('.active');

    if (activeElements.length > 0) {
      // If any element has the 'active' class, add the 'invisible' class to all elements with the 'test' class
      testElements.forEach(el => {
        el.classList.add('invisible');
      });
    } else {
      // If no elements have the 'active' class, remove the 'invisible' class from all elements with the 'test' class
      testElements.forEach(el => {
        el.classList.remove('invisible');
      });
    }
  }


  closeAll() {
    this.targets.forEach(el => {
      el.classList.remove('active');
    });
  }
}

export default InteractiveLegend;
